import { useQuery } from '@tanstack/react-query';
import { useAuth } from './useAuth';
import type { AppSettings } from '@shared/schema';

// App-wide experience flags (single row), readable by any signed-in user.
// Drives router gating (classic-view shutdown) and the header toggle.
export function useAppSettings() {
  const { isAuthenticated } = useAuth();

  return useQuery<AppSettings>({
    queryKey: ['/api/app-settings'],
    enabled: isAuthenticated,
  });
}
